import React from 'react';
import { connect } from 'react-redux'
import NuevaSolicitudEmpresa from './NuevaSolicitudEmpresa';

////Importación de actions.
import {
    getScreenData,
    getDataEnterprise,
    saveRequest,
    showError,
    routeToNuevaSolicitudCuenta,
    routeToPrevious,
    routeToCancel,
    routeToLimits,
    routeToNewEnterprise,
    guardarSolicitudBorrador,
    editNewEnterprise,
    seleccionarEmpresa,
    openModalDistribucionLimites,
    closeModalDistribucionLimites,
    closeModal,
    actualizarLimites,
    closeModalInformacionEmpresa,
    openModalInformacionEmpresa,
    resetStateSolicitudEmpresa
} from '../actions/NuevaSolicitudEmpresaActions';


const mapStateToProps = (state) => {
    return {
        data: state.nuevaSolicitudEmpresa,
        distribucionLimites: state.distribucionLimites,
        tarjetas: state.tarjetas
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getScreenData: (state, currentScope, dataSolicitud) => {
            dispatch(getScreenData(state, currentScope, dataSolicitud));
        },
        getDataEnterprise: (id) => {
            dispatch(getDataEnterprise(id));
        },
        saveRequest: (id) => {
            dispatch(saveRequest(id));
        },
        showError: () => {
            dispatch(showError());
        },
        routeToNuevaSolicitudCuenta: () => {
            dispatch(routeToNuevaSolicitudCuenta());
        },
        routeToPrevious: () => {
            dispatch(routeToPrevious());
        },
        routeToCancel: () => {
            dispatch(routeToCancel());
        },
        routeToLimits: () => {
            dispatch(routeToLimits());
        },
        routeToNewEnterprise: () => {
            dispatch(routeToNewEnterprise());
        },
        guardarSolicitudBorrador: () => {
            dispatch(guardarSolicitudBorrador());
        },
        editNewEnterprise: (id) => {
            dispatch(editNewEnterprise(id));
        },
        seleccionarEmpresa: (id) => {
            dispatch(seleccionarEmpresa(id));
        },
        openModalDistribucionLimites: () => {
            dispatch(openModalDistribucionLimites());
        },
        closeModalDistribucionLimites: () => {
            dispatch(closeModalDistribucionLimites());
        },
        closeModal: () => {
            closeModal();
        },
        actualizarLimites: (estado) => {
            dispatch(actualizarLimites(estado));
        },
        openModalInformacionEmpresa: (id) => {
            dispatch(openModalInformacionEmpresa(id));
        },
        closeModalInformacionEmpresa: () => {
            dispatch(closeModalInformacionEmpresa());
        },
        resetStateSolicitudEmpresa: () => {
            dispatch(resetStateSolicitudEmpresa());
        }
    }
}

//Connect entre el componente y las props y actions.
const NuevaSolicitudEmpresaContainer = connect(mapStateToProps, mapDispatchToProps)(NuevaSolicitudEmpresa);

export default NuevaSolicitudEmpresaContainer;
